let path = "https://cep360.kestoneapps.in";
if (process.env.NODE_ENV === "development") {
  path = "http://localhost:4020";
}
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
  patch: "patch",
};
// export const basePath = "https://cep360.kestoneapps.in";
// export const apiPath = "/api";
export const basePath = path;
export const apiPath = basePath + "/api";

export const apiLoginUser = "/auth/login";
export const apiAuthResetPassword = "/auth/resetPassword";
export const apiLogutUser = "/auth/logout";
export const apiGetUser = "/auth/user";
export const apiGetAllUsers = "/auth/allusers";
export const apiRegisterUser = "/auth/register";
export const apiUpdateUser = "/auth/user";
export const apiGetUserByRole = "/auth/users-by-role";
export const apiBulkCreateAgents = "/auth/bulk-create-agents";
export const apiChangeOwnPassword = "/auth/change-password";
export const apiCreateCampaign = "/campaign/create";
export const apiUpdateCampaign = "/campaign/update";
export const apiGetCampaigns = "/campaign/allCampaigns";
export const apiGetCampaignsById = "campaign/getCampaignByUserId";
export const apiGetCampaignDetailsByCampaignId = "/campaign/getCampaignById";

export const apiUploadDatabase = "/callingData/upload-database";
export const apiGetCampaignDatabase = "/callingData/getAllCallingData";
export const campaignDataByAssignment = "/callingData/campaignDataByAssignment";
export const campaignDataByAssignmentUnmasked =
  "/callingData/campaignDataByAssignmentUnmasked";

export const apiGetCallingDataById = "/callingData/getCallingDataById";
export const apiUpdateCallingData = "/callingData";
export const apiUpdateDirectCallingData = "/callingData/updateCallingData";
export const apiSetPriority = "/callingData/setPriority";
export const apiGetPriorityList = "/callingData/getPriorityList";
export const apiClosePriority = "/callingData/closePriority";
//external registrations api
export const apiUploadExternalRegistrations =
  "/callingData/externalRegistrationData";
export const apiGetExternalRegistrations =
  "/callingData/getAllExternalRegistrations";
export const assignCallingDataToAgents =
  "/callingData/assignCallingDataToAgents";
export const unassignCallingDataFromAgents =
  "/callingData/unassignCallingDataFromAgents";
export const reassignCallingDatatoAgents =
  "/callingData/reassignCallingDatatoAgents";
//agents api
export const apiGetAllAgents = "/agent/getAllNonAssignedAgents";
export const apiGetAllAssignedAgents = "/agent/getAllAssignedAgents";
export const assignAgents = "/agent/assignAgents";
export const apigetAllocAndUnalloclist = "/agent/getAllocAndUnalloclist";
export const apireleaseAgent = "/agent/releaseAgents";
export const apiGetCampaignByAgentId = "agent/getCampaignByAgentId";
export const apiGetCallingDataByAgentIdAndCampaignId =
  "/agent/getCallingDataByAgentIdAndCampaignId";
export const getCallingDataByAgent = "/agent/getCallingDataByAgent";
export const apiGetEngagementHistory = "/agent/engagementHistory";

//callHistory api

export const apiCreateHistory = "callHistory/create";
export const apiUpdateHistory = "callHistory/update";
export const apiUploadFile = "/upload/upload";

//callRecoreding
export const apiCreateCallRecording = "callHistory/createCallRecording";

// Tata SmartFlo calling (extension / softphone approach)
export const apiTataCall        = "/tataCalling/call";          // POST — initiate
export const apiTataLive        = "/tataCalling/live";          // GET
export const apiTataHangupCall  = "/tataCalling/hangup";        // PUT  — hangup
export const apiTataUpdateCallId = "/tataCalling/updateCallId"; // PATCH
export const apiTataCallStatus  = "/tataCalling/status";        // GET  /:callId

//Invoice api
export const apiGetAllInvoicesData = "/invoice/allInvoiceData";
export const apiGetInvoiceAgents = "invoice/getAgentsByProgramManager";
export const apiGetInvoiceAgentDataByMonth =
  "invoice/getAgentInvoicesDataByMonth";
export const apiUpdateAndGenerateInvoice = "invoice/updateAndGenerateInvoice";
export const apiGetInvoicesByPMAndMonth = "invoice/getInvoicesByPMAndMonth";
export const apiGetInvoicesOfAgent = "invoice/getInvoicesOfAgent";
export const apiGetAllInvoicesOfPmMonthWise =
  "invoice/getAllInvoicesOfPmMonthWise";

//dashboard api

export const apiGetDashboardData = "dashboard/dashboardData";
export const apiAllAgentsReportData = "dashboard/allAgentsReportData";
export const apiCallHistoryReport = "/dashboard/callHistoryReport";
export const apiGetHourlyAnalysis = "/dashboard/hourlyAnalysis";

export const apiGetAttendanceByPmAndMonth =
  "/attendence/attendenceByPmAndMonth";

export const apigetAllAttendenceDetails = "/attendence/getAllAttendenceDetails";

//master db
export const apiGetAllUsersMasterdb = "/masterdb/getAllData";
export const apiGetAllMasterDataWithEngagements =
  "/masterdb/getContactsWithEngagements";
export const apiGetAllCompaniesMasterdb = "/masterdb/getAllCompanyData";
export const apiAddNewCompanyMasterdb = "/masterdb/AddNewCompany";
export const apiGetAllCompanyName = "/masterdb/getAllCompanyName";
export const apiUpdateUserMasterdb = "/masterdb/update";
export const apiAddDataBatchToMasterdb = "/masterdb/batchCreateFromExcel";
export const apigetDropdownFiltersData = "/masterdb/getDropdownFilters";
export const apiGetCompanyById = "/masterdb/getCompanyDataById";
export const apiMergeCompanies = "/masterdb/mergeCompanies";
export const apiIndividualSearch = "/masterdb/individualSearch";
export const apiAssignIndividualSearch = "/masterdb/assignIndividualSearch";
// export const apiGetFiltersStats = "/masterdb/getFiltersStats";
export const apiGetFiltersStats = "/filtration/callingDataFilter";
export const apiClientCallingDataFilter = "/filtration/clientCallingDataFilter";
export const apiGetAllFilteredDataSummary =
  "/filtration/getPrevCampFiltersByCampaignId";

//magicLinks
export const apiGenerateMagicLink = "/filtration/generate";
export const apifilterResultsSummary = "/filtration/filterResultsSummary";

//for updating campaign data source type and stage
export const apiUpdateCampaignDataSourceType =
  "/campaign/updateCampaignDataSourceType";
export const apiUpdateCampaignStage = "/campaign/updateCampaignStage";

export const apiGetAllcompaniesMatchedData =
  "/filtration/companiesMatchedDataWithExcel";
export const apiMatchJobStatus = "/filtration/matchJobStatus";
export const apiGetClientMatchData = "/filtration/clientMatchData";
export const apiGetClientMatchSessionData = "/filtration/clientMatchData";
export const apiUpdateClientMatchAction = "/filtration/clientMatchData";

//for assignCallingDataToCampaign
export const apiAssignCallingDataToCampaign =
  "/filtration/assignCallingDataToCampaign";
export const apiAssignCallingDataToCampaignBoth =
  "/filtration/assignCallingDataToCampaignBoth";
export const assignCallingDataToCampaignClientSuggested =
  "/filtration/assignCallingDataToCampaignClientSuggested";

//for approval data
export const apiGetPendingEditApprovals =
  "/callingDataEditApproval/pending-edit-approvals";
export const apiApproveOrRejectEditApproval =
  "/callingDataEditApproval/approve-reject-edit-request";

//webhooks related apis
export const apiGetAllEmailData = "/webhook/GetAllMailSentStatus";

//email teplate related apis
export const apiGetAllTemplateData = "/template/getAllTemplateData";
export const apiCreateTemplate = "/template/createAndLinkTemplate";
export const apiUpdateTemplate = "/template/updateTemplate";
export const apiSendEmailWithTemplate = "/mailercloud/sendEmailWithTemplate";
export const apiGetMailerCloudTemplateDetails =
  "/template/getMailerCloudTemplateDetails";
export const apiGetAllEmailStatus = "/GetAllEmailStatus";

export const apiUploadLinkedProfilesCsv = "/linkedin/uploadLinkedinCsv";
export const apiGetAllLiinkedinProfiles = "/linkedin/getAllEnrichedProfiles";

// reconfirmation campaign
export const apiCreateReconfirmationCampaign = "/campaign/createReconfirmation";
export const apiGetReconfirmationCampaigns = "/campaign/getReconfirmationCampaigns";

//Whatapp related apis
export const apiGetAllWhatsappTemplates = "/whatsapp/getAllWhatsappTemplates";
export const apiSendWhatsappMessage = "/whatsapp/sendTemplateMessage";
